export { renderRangeSlider_unstable as renderRangeSlider } from '@fluentui/react-range-slider-preview';
